<template>
  <v-card class="v-card v-sheet theme--light v-card-100">
    <!-- Title-->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition" >{{ alert_message }}</v-alert >
    </div>
    <loading v-model:active="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage" :color="primary_code" />
            
    <!-- <div>
      <div
        v-if="
            headerText === 'D2C Return Approval' ||
            headerText === 'Warranty Claim Approval' ||
            headerText === 'Dealer/Partner Return Approval' ||
            headerText === 'Internal Return Request Approval'">
        <HeaderComponent
          :headerTitle="headerText".dynamic-height-dis-card {
    height: calc(var(--vh, 1vh) * 100 - 170px) !important;
  }
          :router-link="getRouterLink()"
          :router-link-text="getRouterLinkText()"
          :return-condition="true"
          :component-name="componentsName()"/>
      </div>
    </div> -->

    <v-card style="padding: 20px;" class="v-card-100">
      <v-row>
        <v-col cols="12" sm="6" lg="6" md="6" class="text-left">
          <v-combobox 
            v-model="selectedmethod" 
            :items="settlement_details" 
            item-title="original_code" 
            item-value="id" 
            color="primary" 
            label="Select Method" 
            variant="outlined" 
            @update:modelValue="autoPopulate(selectedmethod)" 
            :disabled="action === 'from_home_approve' && is_initial_request_approval === false">
            </v-combobox>
        </v-col>
        
        <!-- Display refund percentage and refund value fields for specific methods -->
        <v-col v-if="showRefundFields(selectedmethod)" cols="12" sm="3" md="3" lg="3" class="text-left">
          <v-text-field
            variant="outlined"
            v-model="refundPercentage"
            :readonly="selectedmethod === 'Full Refund'"
            label="Refund Percentage (%)"
            @keyup="refundPerch(refundPercentage)"
            :rules="refundPercentageRules"
            color="primary"
          ></v-text-field>
        </v-col>
        <!-- Display dropdown recevery field methods -->
        <v-col v-if="showDropdownRecoveryMethodField(selectedmethod)" cols="12" sm="4">
          <v-autocomplete
            v-model="recovery_method"
            variant="outlined"
            :items="internal_recovery_methods"
            label="Select Recovery Method"
            item-value="id"
            item-title="name"
            color="primary"
          ></v-autocomplete>
      <v-row v-for="(row, index) in rows" :key="index">
        <v-col v-if="showDropdownRecoveryMethodField(selectedmethod)" cols="12" sm="6">
          <v-text-field
            variant="outlined"
            v-model="row.vendor_id"
            label="Enter Vendor ID"
            
            :rules="validateUniqueVendorId(row.vendor_id) ? [] : ['Vendor ID must be unique']"
          ></v-text-field>
        </v-col>
        <v-col v-if="showDropdownRecoveryMethodField(selectedmethod)" cols="12" sm="6">
          <v-text-field
            variant="outlined"
            v-model="row.debit_amount"
            label="Debit Note (₹)"
            :min="0"
            type="number"
            
            :rules="validatePurchasePrice() ? [] : [`Total debit amount must not exceed purchase price`]"
          ></v-text-field>
        </v-col>
        </v-row>
          <v-row >
          <v-col v-if="showDropdownRecoveryMethodField(selectedmethod)" cols="12" sm="6">
            <v-btn        
          color="primary"
          class="ma-2 m-0"
          variant="outlined"
          @click="addNewRow(row, index)"
          style="color:white;"
          :disabled="checkDisabilityAddMore()">
          <v-icon class="mr-1">mdi-plus</v-icon>ADD VENDOR
         </v-btn>
          </v-col>
          <v-col v-if="showDropdownRecoveryMethodField(selectedmethod)" cols="12" sm="6">
            <v-btn        
          color="primary"
          class="ma-2 ma-0"
          variant="outlined"
          @click="addNewRow(row, index)"
          style="color:white;"
          :disabled="checkDisabilityNote()">
          <v-icon class="mr-1">mdi-plus</v-icon>ADD DEBIT NOTE
         </v-btn>
          </v-col>
        </v-row>
        </v-col>
       
      
        <v-col v-if="showRefundFields(selectedmethod) && action !== 'from_home_approve'" cols="12" sm="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            v-model="refundValue"
            label="Refund Value (₹)"            
            :min="0"
            type="number"
            :readonly="selectedmethod === 'Full Refund'"
            oninput="validity.valid||(value='');"
            @keyup="refundValueAmount(refundValue)"
            color="primary"
          ></v-text-field>
        </v-col>
        <v-col v-if="showRefundWithItemFields(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            :rules="refundPercentageRules"
            v-model="refundPercentageWithItem"
            label="Refund Percentage (%)"
            @keyup="refundPerchWOReWD(refundPercentageWithItem)"
          ></v-text-field>
        </v-col>
        <v-col v-if="showRefundWithItemFields(selectedmethod) && action !== 'from_home_approve'" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            v-model="refundValueWithItem"
            label="Refund Value (₹)"
            
            :min="0"
            type="number"
            oninput="validity.valid||(value='');"
            @keyup="refundValueAmountWOReWD(refundValueWithItem)"
          ></v-text-field>
        </v-col>
         <v-col v-if="showRefundWithOuyItemFields(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            :rules="refundPercentageRules"
            v-model="refundPercentageWithoutItem"
            label="Refund Percentage (%)"
            
            @keyup="refundPerchWOReWOD(refundPercentageWithoutItem)"
          ></v-text-field>
        </v-col>
        <v-col v-if="showRefundWithOuyItemFields(selectedmethod) && action !== 'from_home_approve'" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            v-model="refundValueWithOutItem"
            label="Refund Value (₹)"
            
            :min="0"
            type="number"
            oninput="validity.valid||(value='');"
            @keyup="refundValueAmountWOReWOD(refundValueWithOutItem)"
          ></v-text-field>
        </v-col>
        <!-- Refund without -->
        <v-col v-if="showRefundWithoutFields(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            :rules="refundPercentageRules"
            v-model="refundWithoutPercentage"
            label="Refund Percentage (%)"            
            @keyup="refunWithoutdPerch(refundWithoutPercentage)"
          ></v-text-field>
        </v-col>
        <v-col v-if="showRefundWithoutFields(selectedmethod) && action !== 'from_home_approve'" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            v-model="refundWithoutValue"
            label="Refund Value (₹)"
            
            :min="0"
            type="number"
            oninput="validity.valid||(value='');"
            @keyup="refundWithoutValueAmount(refundWithoutValue)"
          ></v-text-field>
        </v-col>
        <!-- Discount fields -->
        <v-col v-if="showDiscountFields(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            :rules="refundPercentageRules"
            v-model="discountPercentage"
            label="Discount Percentage (%)"
            
            @keyup="discounrPerch(discountPercentage)"
          ></v-text-field>
        </v-col>
        <v-col v-if="showDiscountFields(selectedmethod) && action !== 'from_home_approve'" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            v-model="discountValue"
            label="Discount Value (₹)"
            
            :min="0"
            type="number"
            oninput="validity.valid||(value='');"
            @keyup="discountValueFun(discountValue)"
          ></v-text-field>
        </v-col>
         <v-col v-if="showDiscountWithoutDepFields(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            :rules="refundPercentageRules"
            v-model="discountPercentageWithout"
            label="Discount Percentage (%)"
            
            @keyup="discounrPerchWoDe(discountPercentageWithout)"
          ></v-text-field>
        </v-col>
        <v-col v-if="showDiscountWithoutDepFields(selectedmethod) && action !== 'from_home_approve'" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            v-model="discountValueWithout"
            label="Discount Value (₹)"
            
            :min="0"
            type="number"
            oninput="validity.valid||(value='');"
            @keyup="discountValueFunWoDe(discountValueWithout)"
          ></v-text-field>
        </v-col>
        <!-- Display article id and article description fields for specific methods -->
        <v-col v-if="showArticleFields(selectedmethod)" cols="12" sm="2">
          <v-text-field
            variant="outlined"
            v-model="articleId"
            label="Article ID"
            disabled
          ></v-text-field>
        </v-col>
        <v-col v-if="showArticleFields(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            v-model="articleDescription"
            label="Article Description"
            disabled
          ></v-text-field>
        </v-col>
        <!-- without replacement -->
        <v-col v-if="showArticleWithoutFields(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            v-model="articleWithoutId"
            label="Article ID"
            disabled
          ></v-text-field>
        </v-col>
        <v-col v-if="showArticleWithoutFields(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            v-model="articleWithoutDescription"
            label="Article Description"
            disabled
          ></v-text-field>
        </v-col>
        <v-col v-if="showArticleFieldsWithoutRWOD(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            v-model="articleWithoutIdWORWOD"
            label="Article ID"
            disabled
          ></v-text-field>
        </v-col>
        <v-col v-if="showArticleFieldsWithoutRWOD(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            v-model="articleWithoutDescriptionWORWOD"
            label="Article Description"
            disabled
          ></v-text-field>
        </v-col>
         <v-col v-if="showArticleFieldsWithoutRWD(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            v-model="articleWithoutIdWORWD"
            label="Article ID"
            disabled
          ></v-text-field>
        </v-col>
        <v-col v-if="showArticleFieldsWithoutRWD(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-text-field
            variant="outlined"
            v-model="articleWithoutDescriptionWORWD"
            label="Article Description"
            disabled
          ></v-text-field>
        </v-col>
        <!-- Display dropdown field for specific methods -->
        <v-col v-if="showDropdownField(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-autocomplete
            v-model="repairType"
            variant="outlined"
            :items="repair_location"
            label="Repair Type"
            item-value="id"
            item-title="name"
            class="text-left"
            
          ></v-autocomplete>
        </v-col>
        <!-- paid field -->
        <v-col v-if="showDropdownPaidField(selectedmethod)" cols="12" m="3" md="3" lg="3">
          <v-autocomplete
            v-model="repairPaidType"
            variant="outlined"
            :items="repair_location"
            label="Repair Type"
            item-value="id"
            item-title="name"
            
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-text-field
            variant="outlined"
            v-model="comment"
            label="Add Comment"
            @click="toggleReject()"
            color="primary"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" md="2" lg="2">
          <v-btn class="float-right text-none w-100" size="x-large" color="primary" @click="d2cReturnApproval('Approve')" :disabled="!enableButtonApprove">Approve</v-btn>
        </v-col>
        <v-col cols="12" sm="2" md="2" lg="2">
          <v-btn v-if="!(currentUser.roles.includes('branch_manager'))" class="float-right text-none w-100" size="x-large" color="primary" @click="d2cReturnApproval('Repropose')" :disabled="!enableButtonApprove">Re Propose</v-btn>
        </v-col>
        <v-col cols="12" sm="2" md="2" lg="2">
          <v-btn class="float-right text-none w-100" size="x-large" color="primary" @click="d2cReturnApproval('Reject')" :disabled="isRejectDisabled">Reject</v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!--item popup-->
    <v-row justify="center">
      <v-dialog
        v-model="itemPopup"
        persistent
        max-width="845px"
        class="ml-3 mr-3"
      >
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex">Error Message
            <v-spacer></v-spacer>
            <v-btn icon @click="itemPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <p style="color: red;">
            ! The Selected Model is Not Available in Inventory
          </p>
          <p>Select Replacement With Alternative Model</p>
          <v-data-table
            :headers="tableHeaders"
            :items="tableData"
            class="elevation-1"
          >
            <template #[`item.articleId`]="{item}">
              <v-row
                style="cursor: pointer;"
                @click="selectArticle(item.articleId)"
              >
                <v-col>{{ item.articleId }}</v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Approve Success popup -->
    <v-row justify="center">
      <v-dialog v-model="approvePopup" persistent max-width="587px">
        <v-card class="v-card-100 pa-2">
          <!-- <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="approvePopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title> -->
          <!-- <v-divider :thickness="4" class="m-0" /> -->
          <v-card-actions center class="mt-2">
            <v-row style="text-align:center;">
              <v-col>
                <strong>
                  {{ success_message }}
                </strong>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions center>
            <v-row style="text-align:center">
              <v-col>
                <v-btn  color="primary" @click="naviegateToHome" variant="flat">
                  Ok
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>
<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import Loading from 'vue-loading-overlay';
// import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    HeaderComponent, Loading
  },
  props: {
    start_loading : Function,
    stop_loading : Function
  },
  data() {
    return {
      headerText: "",
      action: "Approval Decision",
      replacementSelected: false,
      article_discription: "",
      article_id: "",
      comment: "",
      refundEnabled: false,
      refundWithoutEnabled: false,
      refundDiscountEnabled: false,
      refund_value: "",
      refund_without_percentage: "100",
      refund_without_value: "",
      discount_percentage: "",
      discount_value: "",
      itemPopup: false,
      approvePopup: false,
      buttonDisable: true,
      item: [],
      articleId: "",
      tableHeaders: [
        { text: "Article Id", value: "articleId" },
        { text: "Quantity", value: "quantity", align: "right" }
      ],
      tableData: [
        { articleId: "247801", quantity: 20 },
        { articleId: "247802", quantity: 15 },
        { articleId: "247803", quantity: 10 },
        { articleId: "247808", quantity: 12 },
        { articleId: "247804", quantity: 20 },
        { articleId: "247805", quantity: 15 },
        { articleId: "247806", quantity: 10 },
        { articleId: "247807", quantity: 12 }
      ],
      settlement_details: "",
      selectedMethodId: null,
      refundPercentage: "",
      refundValue: "",
      articleId: "",
      articleDescription: "",
      repairType: null,
      refundWithoutPercentage: "100",
      refundWithoutValue: "",
      articleWithoutId: "",
      articleWithoutDescription: "",
      repairPaidType: null,
      repair_location: "",
      success_message: "",
      alert_type: "success",
      alert_message: "success",
      alert: false,
      internal_recovery_methods:'',
      recovery_method:'',
      discountValue: "",
      discountPercentage: "",
      currentUser: {},
      rows: [
                {
                  vendor_id: '',
                  debit_amount: ''
                }
          ],
      primary_code: "#0275d8",
      fullPage : true,  
      original_name:'',
      purchasePriceLimit: 5000,
      refundPercentageWithItem:'',
      refundValueWithItem:'',
      refundPercentageWithoutItem:100,
      refundValueWithOutItem :'',
      discountPercentageWithout:'',
      discountValueWithout:'',
      articleWithoutIdWORWOD:'',
	    articleWithoutDescriptionWORWOD:'',
      articleWithoutIdWORWD:'',
    	articleWithoutDescriptionWORWD:'',
      action:'',
      return_item:'',
      settlement_method_check:'',
      purchase_date_check:'',
      purchase_price_check:'',
      errorMessages: [],
      selectedmethod:null,
      original_code:[],
      valid_condt:true,
      is_initial_request_approval:'',
      number:0,
      organization_name: ''
    };
  },
  async created() {
    if(this.$store.state.action === 'by_link_approve'){
      this.is_initial_request_approval = this.$store.state.set_unique
    }else{
     this.is_initial_request_approval = this.$store.state.set_unique[0]
    }
    this.action = this.$store.state.action
    this.item_id = this.$store.state.lotIds.id;
    this.headerText = this.$store.state.inventoryId;
    this.currentUser = this.$store.state.currentUser;
    this.organization_name = this.$store.state.organization_name
    this.fetchSettlementData();
  },
  computed: {
    refundPercentageRules() {
      return [
         v => {
          if(v){
           const isValid = !v || v <= 100 || 'Percentage should be less than or equal to 100';        
            this.valid_condt = isValid === true;
             return isValid;
          }else{
            this.valid_condt = false;
          }
        
         },
      ];

    },
    enableButtonApprove(){
      const numberCheck = this.number != 1;
      if(this.action === 'from_home_approve' && this.is_initial_request_approval === false){
        return numberCheck && this.comment;
      }else if(this.original_name === 'Repair FOC' && this.action === 'from_home_approve'){
        return numberCheck && this.comment && this.selectedMethodId && this.original_name !== 'Reject';
      }else if(this.original_name === 'Repair Paid' && this.action === 'from_home_approve'){
        return numberCheck && this.comment && this.selectedMethodId && this.original_name !== 'Reject';
      }else if(this.original_name === 'Repair FOC'){
        return numberCheck && this.comment && this.selectedMethodId && this.repairType && this.original_name !== 'Reject';
      }else if(this.original_name === 'Repair Paid'){
        return numberCheck && this.comment && this.selectedMethodId && this.repairPaidType && this.original_name !== 'Reject';
      }else{
        return numberCheck && this.comment && this.selectedMethodId && this.original_name !== 'Reject' && ((this.original_name && this.original_name.split(' ')[0] === 'Replacement') || this.valid_condt);
      }     
    },
    isRejectDisabled() {
      if(this.action === 'from_home_approve' && this.is_initial_request_approval === false){
        return ( !this.comment || this.number > 0);
      }else{
       return (
        !this.comment ||
        !(this.original_name === 'Reject' || 
          this.original_name === 'Return with Debit' || 
          this.original_name === 'Return without Debit') ||
        this.currentUser.roles.includes('default_user') ||
        this.number > 0
      );
      }
      
    },

    enableButtonRepropose(){
      if(this.original_name === 'Repair FOC' && this.action === 'single_item_approve'){
        return this.comment && this.selectedMethodId && this.original_name !== 'Reject' && !this.currentUser.roles.includes('default_user') && !this.is_initial_request_approval;
      }else if(this.original_name === 'Repair FOC' && this.action === 'single_item_approve'){
        return this.comment && this.selectedMethodId && this.original_name !== 'Reject' && !this.currentUser.roles.includes('default_user') && !this.is_initial_request_approval;
      }else if(this.original_name === 'Repair FOC' && this.action === 'from_home_approve'){
        return this.comment && this.selectedMethodId && this.original_name !== 'Reject' && !this.currentUser.roles.includes('default_user') && !this.is_initial_request_approval;
      }else if(this.original_name === 'Repair Paid' && this.action === 'from_home_approve'){
        return this.comment && this.selectedMethodId && this.original_name !== 'Reject' && !this.currentUser.roles.includes('default_user') && !this.is_initial_request_approval;
      }else if(this.original_name === 'Repair FOC'){
        return this.comment && this.selectedMethodId && this.repairType && this.original_name !== 'Reject' && !this.currentUser.roles.includes('default_user') && !this.is_initial_request_approval;
      }else if(this.original_name === 'Repair Paid'){
        return this.comment && this.selectedMethodId && this.repairPaidType && this.original_name !== 'Reject' && !this.currentUser.roles.includes('default_user') && !this.is_initial_request_approval;
      }else if(this.action === 'from_home_approve'){
        return this.comment && this.selectedMethodId  && !this.currentUser.roles.includes('default_user') && !this.is_initial_request_approval;  
      }else{
        return this.comment && this.selectedMethodId && this.original_name !== 'Reject' && !this.currentUser.roles.includes('default_user') && !this.is_initial_request_approval;
      }     
    }
  },
  methods: {
    isMethodSelected(methodId) {
      return this.selectedMethodId === methodId;
    },
    showRefundFields(methodId) {
      return ['Refund with Return of item with Depreciation', 'Full Refund'].includes(methodId);
    },
    showRefundWithoutFields(methodId) {
      return ['Refund with Return of item without Depreciation'].includes(methodId);
    },
    showRefundWithOuyItemFields(methodId) {
      return ['Refund without Return of item without Depreciation'].includes(methodId);
    },
    showRefundWithItemFields(methodId) {
      return ['Refund without Return of item with Depreciation'].includes(methodId);
    },
    showDiscountFields(methodId) {
      return ['Discount with Depreciation'].includes(methodId);
    },
    showDiscountWithoutDepFields(methodId) {
      return ['Discount without Depreciation'].includes(methodId);
    },
    showArticleFields(methodId) {
      if(this.action !== 'from_home_approve')
      return ['Replacement with Return of item with Depreciation'].includes(methodId);
    },
    showArticleWithoutFields(methodId) {
      if(this.action !== 'from_home_approve')
      return ['Replacement with Return of item without Depreciation'].includes(methodId);
    },
    showArticleFieldsWithoutRWOD(methodId) {
      if(this.action !== 'from_home_approve')
      return ['Replacement without Return of item without Depreciation'].includes(methodId);
    },
    showArticleFieldsWithoutRWD(methodId) {
      if(this.action !== 'from_home_approve')
      return ['Replacement without Return of item with Depreciation'].includes(methodId);
    },
    showDropdownField(methodId) {
      if(this.action !== 'from_home_approve')
      return ['Repair FOC'].includes(methodId);
    },
    showDropdownPaidField(methodId) {
      if(this.action !== 'from_home_approve')
      return ['Repair Paid'].includes(methodId);
    },
    showDropdownRecoveryMethodField(methodId) {
      if(this.action !== 'from_home_approve')
      return ['Return with Debit'].includes(methodId);
    },
    getRouterLink() {
      if (this.headerText === "D2C Return Approval" && this.action !== "from_home_approve") {
        this.$store.commit("setLotIds", {
          lotIds: this.$store.state.lotIds,
          inventoryId: "D2C Return Approval"
        });
        return { name: "sub_request_approval" };
      } else if (this.headerText === "Warranty Claim Approval" && this.action !== "from_home_approve") {
         this.$store.commit("setLotIds", {
          lotIds: this.$store.state.lotIds,
          inventoryId: "Warranty Claim Approval"
        });
        return { name: "sub_request_approval" };
      } else if (this.headerText === "Customer Case Approval" && this.action !== "from_home_approve") {
         this.$store.commit("setLotIds", {
          lotIds: this.$store.state.lotIds,
          inventoryId: "Customer Case Approval"
        });
        return { name: "sub_request_approval" };
      }else if (this.headerText === "Dealer/Partner Return Approval" && this.action !== "from_home_approve") {
        this.$store.commit("setLotIds", {
          lotIds: this.$store.state.lotIds,
          inventoryId: "Dealer/Partner Return Approval"
        });
        return { name: "sub_request_approval" };
      }else if(this.headerText === "Internal Return Request Approval" && this.action !== "from_home_approve"){
        this.$store.commit("setLotIds", {
          lotIds: this.$store.state.lotIds,
          inventoryId: "Internal Return Request Approval"
        });
        return { name: "sub_request_approval" };
      }else if (this.action === 'from_home_approve' && this.headerText === "Warranty Claim Approval"){
        return { name: "dealer_partner_return_approval" };
      }else if (this.action === 'from_home_approve' && this.headerText === "Customer Case Approval"){
        return { name: "dealer_partner_return_approval" };
      }else if (this.action === 'from_home_approve' && this.headerText === "D2C Return Approval"){
        return { name: "dealer_partner_return_approval" };
      }else if (this.action === 'from_home_approve' && this.headerText === "Dealer/Partner Return Approval"){
        return { name: "dealer_partner_return_approval" };
      }else if (this.action === 'from_home_approve' && this.headerText === "Internal Return Request Approval"){
        return { name: "internal_return_approval" };
      }
    },
    getRouterLinkText() {
      if (this.headerText === "D2C Return Approval" && this.action !== 'from_home_approve') {
        return "Sub Location";
      } else if (this.headerText === "Warranty Claim Approval" && this.action !== 'from_home_approve') {
        return this.$store.state.lotIds.return_sub_request_id;
      } else if (this.headerText === "Customer Case Approval" && this.action !== 'from_home_approve') {
        return this.$store.state.lotIds.return_sub_request_id;
      }else if (this.headerText === "Dealer/Partner Return Approval" && this.action !== 'from_home_approve') {
        return this.$store.state.lotIds.return_sub_request_id;
      }else if(this.headerText === "Internal Return Request Approval" && this.action !== 'from_home_approve'){
        return this.$store.state.lotIds.return_sub_request_id;
      }else if (this.action === 'from_home_approve' && this.headerText === "Warranty Claim Approval"){
        return this.headerText
      }else if (this.action === 'from_home_approve' && this.headerText === "Customer Case Approval"){
        return this.headerText
      }else if (this.action === 'from_home_approve' && this.headerText === "D2C Return Approval"){
        return this.headerText
      }else if (this.action === 'from_home_approve' && this.headerText === "Dealer/Partner Return Approval"){
        return this.headerText
      }else if (this.action === 'from_home_approve' && this.headerText === "Internal Return Request Approval"){
        return this.headerText
      }
    },
    itemPopupDisplay() {
      this.itemPopup = true;
      this.buttonDisable = false;
    },
    approvePopupDisplay() {
      this.approvePopup = true;
    },
    componentsName() {
      if (this.headerText === "D2C Return Approval") {
        return "Approval Decision";
      } else if (this.headerText === "Warranty Claim Approval") {
        return "Approval Decision";
      } else if (this.headerText === "Dealer/Partner Return Approval") {
        return "Approval Decision";
      }else if (this.headerText === "Internal Return Request Approval"){
        return "Approval Decision"
      }
    },
    toggleTextFields(event) {
      this.refundEnabled = event.target.checked;
      this.buttonDisable = false;
    },
    toggleSecondFields(event) {
      this.refundWithoutEnabled = event.target.checked;
      this.buttonDisable = false;
    },
    toggleDiscountFields(event) {
      this.refundDiscountEnabled = event.target.checked;
      this.buttonDisable = false;
    },
    selectArticle(article) {
      this.article_id = article;
      this.closeItemPopup();
    },
    closeItemPopup() {
      this.itemPopup = false;
    },
    toggleReject() {
      this.buttonDisable = false;
    },
    fetchSettlementData() {
      this.loading = true;
      this.start_loading()
      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/return_approvals/get_settlement_methods`)
        .then(response => {
        if((response.data && this.headerText === "D2C Return Approval") || (response.data && this.headerText === "Dealer/Partner Return Approval") || (response.data && this.headerText === "Warranty Claim Approval") || (response.data && this.headerText === "Customer Case Approval")) {
            this.settlement_details = response.data.d2c_return_methods;
            this.loading = false;
            this.stop_loading()
            this.fetchEnumsData();
          } else if((response.data && this.headerText === 'Internal Return Request Approval')) {
            this.settlement_details = response.data.int_return_methods;
            this.loading = false;
            this.stop_loading()
            this.fetchEnumsData();
          }else {
            this.loading = false;
            this.stop_loading()
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.stop_loading()
        });
    },
    fetchEnumsData() {
      this.loading = true;
      this.start_loading()
      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/return_approvals/get_enums_data` )
        .then(response => {
          if ((response.data && this.headerText === "D2C Return Approval") ||
              (response.data && this.headerText === "Dealer/Partner Return Approval") || 
              (response.data && this.headerText === "Warranty Claim Approval") || 
              (response.data && this.headerText === "Customer Case Approval")) {
            this.repair_location = response.data.repair_locations;
            this.loading = false;
            this.stop_loading()
            this.itemDetailsFtechData()
          } else if((response.data && this.headerText === "Internal Return Request Approval")) {
            this.internal_recovery_methods = response.data.internal_recovery_methods;
            this.loading = false;
            this.stop_loading()
            this.itemDetailsFtechData()
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.isLoading = false;
        });
    },
    d2cReturnApproval(value) {
      this.number++;
      this.isLoading = true;
      this.start_loading()
      if (this.action === "from_home_approve") {
        if (this.original_name === 'Refund with Return of item with Depreciation') {
          if (this.refundPercentage === "") {
            this.showAlert("error", "Please Enter Refund Percentage (%)");
            this.number = 0;
            return;
          }
        } else if (this.original_name === 'Refund with Return of item without Depreciation') {
          if (this.refundWithoutPercentage === "") {
            this.showAlert("error", "Please Enter Refund Percentage (%)");
            this.number = 0;
            return;
          }
        } else if (this.original_name === 'Refund without Return of item without Depreciation') {
          if (this.refundPercentageWithoutItem === "") {
            this.showAlert("error", "Please Enter Refund Percentage (%)");
            this.number = 0;
            return;
          }
        } else if (this.original_name === 'Refund without Return of item with Depreciation') {
          if (this.refundPercentageWithItem === "") {
            this.showAlert("error", "Please Enter Refund Percentage (%)");
            this.number = 0;
            return;
          }
        } else if (this.original_name === 'Discount without Depreciation') {
          if (this.discountPercentageWithout === "") {
            this.showAlert("error", "Please Enter Discount Percentage (%)");
            this.number = 0;
            return;
          }
        } else if (this.original_name === 'Discount with Depreciation') {
          if (this.discountPercentage === "") {
            this.showAlert("error", "Please Enter Discount Percentage (%)");
            this.number = 0;
            return;
          }
        }
      } else {
        if (this.original_name === 'Refund with Return of item with Depreciation') {
          if (this.refundPercentage === "") {
            this.showAlert("error", "Please Enter Refund Percentage (%)");
            this.number = 0;
            return;
          }
        } else if (this.original_name === 'Refund with Return of item without Depreciation') {
          if (this.refundWithoutPercentage === "") {
            this.showAlert("error", "Please Enter Refund Percentage (%)");
            this.number = 0;
            return;
          }
        } else if (this.original_name === 'Refund without Return of item without Depreciation') {
          if (this.refundPercentageWithoutItem === "") {
            this.showAlert("error", "Please Enter Refund Percentage (%)");
            this.number = 0;
            return;
          }
        } else if (this.original_name === 'Refund without Return of item with Depreciation') {
          if (this.refundPercentageWithItem === "") {
            this.showAlert("error", "Please Enter Refund Percentage (%)");
            this.number = 0;
            return;
          }
        } else if (this.original_name === 'Discount without Depreciation') {
          if (this.discountPercentageWithout === "") {
            this.showAlert("error", "Please Enter Discount Percentage (%)");
            this.number = 0;
            return;
          }
        } else if (this.original_name === 'Discount with Depreciation') {
          if (this.discountPercentage === "") {
            this.showAlert("error", "Please Enter Discount Percentage (%)");
            this.number = 0;
            return;
          }
        }
      }
        const formData = new FormData();
        if(this.action === 'from_home_approve'){
           if (this.original_name === 'Refund with Return of item with Depreciation' || this.original_name === 'Full Refund') {
          formData.append("refund_percent", this.refundPercentage);
        } else if (this.original_name === 'Refund with Return of item without Depreciation') {
          formData.append("refund_percent", this.refundWithoutPercentage);
        } else if (this.original_name === 'Refund without Return of item without Depreciation') {
          formData.append("refund_percent", this.refundPercentageWithoutItem);
        }else if (this.original_name === 'Refund without Return of item with Depreciation') {
          formData.append("refund_percent", this.refundPercentageWithItem);
        }else if (this.original_name === 'Discount without Depreciation') {
          formData.append("discount_percent", this.discountPercentageWithout);
        }else if (this.original_name === 'Discount with Depreciation') {
          formData.append("discount_percent", this.discountPercentage);
        }
        }else{
          if(value === 'Approve'){
            if((this.purchase_price_check === 0 && this.headerText === "Dealer/Partner Return Approval"  && this.organization_name !== "Crompton") || (this.purchase_price_check === '' && this.headerText === "Dealer/Partner Return Approval"  && this.organization_name !== "Crompton")){
            this.showAlert("error", "Please update purchase price before approve");
            this.number = 0;
            return;
          }
           if((this.purchase_date_check === null && this.headerText === "Dealer/Partner Return Approval" && this.organization_name !== "Crompton") || (this.purchase_date_check === '' && this.headerText === "Dealer/Partner Return Approval" && this.organization_name !== "Crompton")){
            this.showAlert("error", "Please update purchase date before approve");
            this.number = 0;
            return;
          }
          }

          if (this.original_name === 'Refund with Return of item with Depreciation' || this.original_name === 'Full Refund') {
          formData.append("refund_percent", this.refundPercentage);
          formData.append("refund_amount", this.refundValue);
        } else if (this.original_name === 'Refund with Return of item without Depreciation') {
          formData.append("refund_percent", this.refundWithoutPercentage);
          formData.append("refund_amount", this.refundWithoutValue);
        } else if (this.original_name === 'Refund without Return of item without Depreciation') {
          formData.append("refund_percent", this.refundPercentageWithoutItem);
          formData.append("refund_amount", this.refundValueWithOutItem);
        }else if (this.original_name === 'Refund without Return of item with Depreciation') {
          formData.append("refund_percent", this.refundPercentageWithItem);
          formData.append("refund_amount", this.refundValueWithItem);
        }else if (this.original_name === 'Discount without Depreciation') {
          formData.append("discount_percent", this.discountPercentageWithout);
          formData.append("discount_amount", this.discountValueWithout);
        }else if (this.original_name === 'Discount with Depreciation') {
          formData.append("discount_percent", this.discountPercentage);
          formData.append("discount_amount", this.discountValue);
        } else if (this.original_name === 'Replacement with Return of item with Depreciation') {
          formData.append("sku_code", this.articleId);
          formData.append("sku_description", this.articleDescription);
        } else if (this.original_name === 'Replacement with Return of item without Depreciation') {
          formData.append("sku_code", this.articleWithoutId);
          formData.append("sku_description", this.articleWithoutDescription);
        }else if (this.original_name === 'Replacement without Return of item without Depreciation') {
          formData.append("sku_code", this.articleWithoutIdWORWOD);
          formData.append("sku_description", this.articleWithoutDescriptionWORWOD);
        }else if (this.original_name === 'Replacement without Return of item with Depreciation') {
          formData.append("sku_code", this.articleWithoutIdWORWD);
          formData.append("sku_description", this.articleWithoutDescriptionWORWD);
        } else if (this.original_name === 'Repair FOC') {
          formData.append("repair_location", this.repairType);
        } else if (this.original_name === 'Repair Paid') {
          formData.append("repair_location", this.repairPaidType);
        }else if(this.original_name === 'Return with Debit'){
          const vendorDetails = [];
            for (let i = 0; i < this.rows.length; i++) {
              vendorDetails.push({
                vendor_id: this.rows[i].vendor_id,
                debit_amount: this.rows[i].debit_amount
              });
            }
            formData.append("vendor_details", JSON.stringify(vendorDetails));
        }  
        }     
       
        let end_point;
        formData.append("comments", this.comment);
        formData.append("action_type", value);
        if (!(this.action === 'from_home_approve' && this.is_initial_request_approval === false)) {
          formData.append("settlement_method_id", this.selectedMethodId);
        }
        if((this.headerText === "D2C Return Approval" && this.action !== 'from_home_approve') || (this.headerText === "Dealer/Partner Return Approval" && this.action !== 'from_home_approve') ||  (this.headerText === "Warranty Claim Approval" && this.action !== 'from_home_approve') ||  (this.headerText === "Customer Case Approval" && this.action !== 'from_home_approve')) 
           {
              end_point = `/api/v1/warehouse/return_initiation/return_approvals/${this.item_id}/approve_d2c_return`;  
            }else if(this.headerText === "Internal Return Request Approval" && this.action !== 'from_home_approve'){
             formData.append("internal_recovery_method", this.recovery_method);
              end_point = `/api/v1/warehouse/return_initiation/return_approvals/${this.item_id}/approve_internal_return`;
            }else if(this.action === 'from_home_approve'){
             formData.append("ids", this.$store.state.lotIds);
              end_point = `/api/v1/warehouse/return_initiation/return_approvals/bulk_approve`
            }
        const method = this.action === 'from_home_approve' ? 'post' : 'put';
        this.$httpSecured[method](end_point, formData)      
          .then(response => {
            if (response.data) {
              this.isLoading = false;
              this.stop_loading()
              this.approvePopup = true;
              if(value === 'Repropose'){
                this.success_message = 'Re-Proposed to the sender'
                this.number = 0;
              }else{
                this.success_message = response.data.message;
                this.number = 0;
              }              
            } else {
              this.number = 0;
              this.showAlert("error", "Something went wrong");
            }
          })
          .catch(error => {
            this.showAlert("error", error.response.data.error || "Something went wrong from Network" + error);
            this.number = 0;
            this.isLoading = false;
            this.stop_loading()
            this.isSubmited = false;
          });
    },
    naviegateToHome() {
      this.approvePopup = false;
      if (this.headerText === "D2C Return Approval") {
        this.$router.push({ name: "dealer_partner_return_approval" });
      } else if (this.headerText === "Dealer/Partner Return Approval") {
        this.$router.push({ name: "dealer_partner_return_approval" });
      }else if(this.headerText === "Warranty Claim Approval" || this.headerText === "Customer Case Approval"){
        this.$router.push({ name: "dealer_partner_return_approval" });     
       }else if(this.headerText === "Internal Return Request Approval"){
        this.$router.push({ name: "internal_return_approval" });
       }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.scrollToTop();
      this.alertTimeOut();
    },

    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    discounrPerch(value){
      if (this.headerText === "Dealer/Partner Return Approval" || this.headerText === 'Warranty Claim Approval' || this.headerText === 'Customer Case Approval') {
        const purchasePrice = this.return_item.purchase_price;
        const depreciationString = this.return_item.depriciation;
        const discountDealer = purchasePrice - depreciationString;
        this.discountValue = (this.formatNumber(discountDealer) * value)/100
      }else{
        this.discountValue = (this.formatNumber(this.$store.state.lotIds.purchase_price) * value)/100
      }
    },
    discounrPerchWoDe(value){
      if (this.headerText === "Dealer/Partner Return Approval") {
        this.discountValueWithout = (this.formatNumber(this.$store.state.lotIds.purchase_price) * value)/100
      }else{
        this.discountValueWithout = (this.formatNumber(this.$store.state.lotIds.purchase_price) * value)/100
      }
    },
    discountValueFun(value){  
      let percentage;    
      if (this.headerText === "Dealer/Partner Return Approval") {
        percentage = (value/this.formatNumber(this.$store.state.lotIds.purchase_price))*100
      }else{
        percentage = (value/this.formatNumber(this.$store.state.lotIds.purchase_price))*100
      }
      this.discountPercentage = this.formatPercentage(percentage);      
      },
      discountValueFunWoDe(value){
        let percentage
        if (this.headerText === "Dealer/Partner Return Approval") {
        percentage = (value/this.formatNumber(this.$store.state.lotIds.purchase_price))*100
      }else{
        percentage = (value/this.formatNumber(this.$store.state.lotIds.purchase_price))*100
      } 
      this.discountPercentageWithout = this.formatPercentage(percentage);     
      },
    refundPerch(value){
      if (this.headerText === "Dealer/Partner Return Approval" || this.headerText === 'Warranty Claim Approval' || this.headerText === 'Customer Case Approval') {
        const purchasePrice = this.return_item.purchase_price;
        const depreciationString = this.return_item.depriciation;
        const discountDealer = purchasePrice - depreciationString;
        this.refundValue = (this.formatNumber(discountDealer) * value) / 100;
      } else {
        this.refundValue = (this.formatNumber(purchasePrice) * value) / 100;
      }
    },
    refundPerchWOReWOD(value){
      if (this.headerText === "Dealer/Partner Return Approval"){
        this.refundValueWithOutItem = (this.formatNumber(this.$store.state.lotIds.purchase_price) * value)/100
      }else{
        this.refundValueWithOutItem = (this.formatNumber(this.$store.state.lotIds.purchase_price) * value)/100
      } 
    },
    refundPerchWOReWD(value){
      if (this.headerText === "Dealer/Partner Return Approval" || this.headerText === 'Warranty Claim Approval' || this.headerText === 'Customer Case Approval'){
        const purchasePrice =this.return_item.purchase_price;
        const depreciationString = this.return_item.depriciation;
        const discountDealer = purchasePrice - depreciationString;
        this.refundValueWithItem = (this.formatNumber(discountDealer) * value)/100
      }else{
        this.refundValue = (this.formatNumber(purchasePrice) * value) / 100;
      } 
    },
    refundValueAmountWOReWOD(value){
      let percentage;
      if (this.headerText === "Dealer/Partner Return Approval"){
        percentage = (value/this.formatNumber(this.$store.state.lotIds.purchase_price) )*100
      }else{
        percentage = (value/this.formatNumber(this.$store.state.lotIds.purchase_price) )*100
      } 
      this.refundPercentageWithoutItem = this.formatPercentage(percentage);     
      },
      refundValueAmountWOReWD(value){
        let percentage;
         if (this.headerText === "Dealer/Partner Return Approval"){
        percentage = (value/this.formatNumber(this.$store.state.lotIds.purchase_price) )*100
      }else{
        percentage = (value/this.formatNumber(this.$store.state.lotIds.purchase_price) )*100
      } 
      this.refundPercentageWithItem = this.formatPercentage(percentage);
      },
    refunWithoutdPerch(value){
      if (this.headerText === "Dealer/Partner Return Approval"){
        this.refundWithoutValue = (this.formatNumber(this.$store.state.lotIds.purchase_price) * value)/100
      }else{
        this.refundWithoutValue = (this.formatNumber(this.$store.state.lotIds.purchase_price) * value)/100
      }
    },
    refundValueAmount(value){
      let percentage;
      if (this.headerText === "Dealer/Partner Return Approval"){
        percentage = (value/this.formatNumber(this.$store.state.lotIds.purchase_price) )*100
      }else{
        percentage = (value/this.formatNumber(this.$store.state.lotIds.purchase_price) )*100
      }  
      this.refundPercentage = this.formatPercentage(percentage);    
      },
      refundWithoutValueAmount(value){
        let percentage;
        if (this.headerText === "Dealer/Partner Return Approval"){
            percentage = (value/this.formatNumber(this.$store.state.lotIds.purchase_price) )*100
            }else{
            percentage = (value/this.formatNumber(this.$store.state.lotIds.purchase_price) )*100
          }
          this.refundWithoutPercentage = this.formatPercentage(percentage);

      },
      formatPercentage(value) {
        const parts = value.toFixed(2).split('.');
        if (parts[1] === '00') {
            return parts[0];
        }
        return value.toFixed(2);
    },
      autoPopulate(value){
        if(!value) return;
        this.selectedmethod = value.original_code
        this.selectedMethodId = value.id
        this.original_name = value.original_code
        if(this.original_name === 'Replacement with Return of item with Depreciation'){
         this.articleId = this.$store.state.lotIds.sku_code
         this.articleDescription = this.$store.state.lotIds.sku_description
         this.articleWithoutId = ''
         this.articleWithoutDescription = ''
         this.articleWithoutIdWORWOD = ''
	        this.articleWithoutDescriptionWORWOD = ''
          this.articleWithoutIdWORWD = ''
          this.articleWithoutDescriptionWORWD = ''
        }else if(this.original_name === 'Replacement with Return of item without Depreciation'){
          this.articleId = ''
          this.articleDescription = ''
          this.articleWithoutId = this.$store.state.lotIds.sku_code
          this.articleWithoutDescription = this.$store.state.lotIds.sku_description
          this.articleWithoutIdWORWOD = ''
	        this.articleWithoutDescriptionWORWOD = ''
          this.articleWithoutIdWORWD = ''
          this.articleWithoutDescriptionWORWD = ''
        }else if(this.original_name === 'Replacement without Return of item without Depreciation'){
          this.articleId = ''
          this.articleDescription = ''
          this.articleWithoutId = ''
          this.articleWithoutDescription = ''
          this.articleWithoutIdWORWOD = this.$store.state.lotIds.sku_code
	        this.articleWithoutDescriptionWORWOD = this.$store.state.lotIds.sku_description
          this.articleWithoutIdWORWD = ''
          this.articleWithoutDescriptionWORWD = ''
        }else if(this.original_name === 'Replacement without Return of item with Depreciation'){
          this.articleId = ''
          this.articleDescription = ''
          this.articleWithoutId = ''
          this.articleWithoutDescription = ''
          this.articleWithoutIdWORWOD = ''
	        this.articleWithoutDescriptionWORWOD = ''
          this.articleWithoutIdWORWD = this.$store.state.lotIds.sku_code
	        this.articleWithoutDescriptionWORWD = this.$store.state.lotIds.sku_description
        }else if(this.original_name === 'Full Refund'){
          this.refundPercentage = 100;
          this.refundValue = this.return_item.purchase_price;
        } else{
          this.articleId = ''
          this.articleDescription = ''
          this.articleWithoutId = ''
          this.articleWithoutDescription = ''
          this.articleWithoutIdWORWOD = ''
	        this.articleWithoutDescriptionWORWOD = ''
          this.articleWithoutIdWORWD = ''
          this.articleWithoutDescriptionWORWD = ''
          this.rows = [
            {
            vendor_id: '',
            debit_amount: ''
            }
          ],
          this.recovery_method = '';
          this.refundPercentage = '';
          this.refundValue = '';
          this.refundPercentageWithItem = '';
          this.refundValueWithItem = '';
          this.discountPercentage = '';
          this.discountValue = '';
          this.discountPercentageWithout = '';
          this.discountValueWithout = '';
          this.repairType = null;
          this.repairPaidType = null;
          this.moduler = [];
          this.refundWithoutPercentage = '';
          this.refundWithoutValue = '';
          this.refundPercentageWithoutItem = 100;
          this.refundValueWithOutItem = ''
        }
      },
      itemDetailsFtechData() {
      if(this.action !== 'from_home_approve'){
        this.loading = true;
      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/return_approvals/${this.item_id}`)
        .then(response => {
          if (response.data) {
            this.loading = false;
            this.return_item = response.data.return_item
            this.prefillDataFromLastUser(response.data.return_item)
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      }
    },
      prefillDataFromLastUser(item){
        this.selectedmethod = this.settlement_details.filter(item1 => item1.id === item.settlement_method_id)[0]
        this.selectedMethodId = item.settlement_method_id
        this.original_name = item.settlement_method
        this.settlement_method_check = item.settlement_method
        this.purchase_price_check = item.purchase_price
        if(this.headerText === "Dealer/Partner Return Approval"){       
          this.purchase_date_check = item.dealer_purchase_invoice_date
        }
    
        this.autoPopulate(this.selectedmethod) 
        // this.comment = item.previous_comments 
        if(item.settlement_method === 'Refund with Return of item with Depreciation' || item.settlement_method === 'Full Refund'){
          this.refundPercentage = item.refund_percent
          this.refundValue = item.refund_amount
        }else if(item.settlement_method === 'Refund with Return of item without Depreciation'){
          this.refundWithoutPercentage = item.refund_percent
          this.refundWithoutValue = item.refund_amount
        }else if(item.settlement_method === 'Refund without Return of item without Depreciation'){
          this.refundPercentageWithoutItem = item.refund_percent
          this.refundValueWithOutItem = item.refund_amount
        }else if(item.settlement_method === 'Refund without Return of item with Depreciation'){
          this.refundPercentageWithItem = item.refund_percent
          this.refundValueWithItem = item.refund_amount
        }else if(item.settlement_method === 'Discount with Depreciation'){
          this.discountPercentage = item.discount_percent
          this.discountValue = item.discount_amount
        }else if(item.settlement_method === 'Discount without Depreciation'){
          this.discountPercentageWithout = item.discount_percent
          this.discountValueWithout = item.discount_amount
        }else if(item.settlement_method === 'Repair FOC'){
          this.repairType = item.repair_location
        }else if(item.settlement_method === 'Repair Paid'){
          this.repairPaidType = item.repair_location
        }else if(item.settlement_method === 'Return with Debit'){
          this.recovery_method = item.internal_recovery_method
          this.rows = item.vendor_details
        }else if(item.settlement_method === 'Replacement with Return of item with Depreciation'){
          this.articleId = item.sku_code
         this.articleDescription = item.sku_description
        }else if(item.settlement_method === 'Replacement with Return of item without Depreciation'){
          this.articleWithoutId = item.sku_code
          this.articleWithoutDescription = item.sku_description
        }else if(item.settlement_method === 'Replacement with Return of item without Depreciation'){
          this.articleWithoutIdWORWOD = item.sku_code
          this.articleWithoutDescriptionWORWOD = item.sku_description
        }else if(item.settlement_method === 'Replacement without Return of item with Depreciation'){
          this.articleWithoutIdWORWD = item.sku_code
          this.articleWithoutDescriptionWORWD = item.sku_description
        }        
      },
      addNewRow() {
          this.rows = [
            ...this.rows,
            {
              vendor_id: "",
              debit_amount: ''
            }
          ];
        },
        checkDisabilityAddMore(){
        const row = this.rows[this.rows.length-1];
        return !row || !row.vendor_id;
      },
      checkDisabilityNote(){
        const row = this.rows[this.rows.length-1];
        return !row || !row.debit_amount;
      },
    formatNumber(value) {
      if (typeof value === 'string') {
        const numberValue = Number(value.replace(/,/g, ''));
        return isNaN(numberValue) ? value : numberValue.toFixed(2);
      } else if (typeof value === 'number') {
          return value.toFixed(2);
      }
    },
  validateUniqueVendorId(vendorId) {
    const duplicateVendorIds = this.rows
      .map(row => row.vendor_id)
      .filter((id, i, arr) => id === vendorId && arr.indexOf(id) !== i);
    return duplicateVendorIds.length === 0;
  },
  getTotalDebitAmount() {
    return this.rows.reduce((total, row) => total + parseFloat(row.debit_amount || 0), 0);
  },
  validatePurchasePrice() {
    return this.getTotalDebitAmount() <= this.$store.state.lotIds.purchase_price;
  },
  formatCurrency(value) {
      return Number(value).toLocaleString('en-IN');
    },
  }
};
</script>
<style scoped>
.custom-radio {
  width: 18px; /* Adjust the size as needed */
  height: 18px; /* Adjust the size as needed */
  margin-right: 8px;
  margin-top:2px;
}
.radio-container {
  display: flex;
  align-items: flex-start; 
}
</style>
